// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Barre d'action au niveau page (ex: Annuler la commande) */
.page-action-bar {
  display: flex;
  justify-content: flex-end;
  padding: 1rem 0;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/SuiviOperationBC/SuiviOperationBC.css"],"names":[],"mappings":"AAAA,4DAA4D;AAC5D;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,gCAAgC;EAChC,mBAAmB;AACrB","sourcesContent":["/* Barre d'action au niveau page (ex: Annuler la commande) */\n.page-action-bar {\n  display: flex;\n  justify-content: flex-end;\n  padding: 1rem 0;\n  border-bottom: 1px solid #e5e7eb;\n  margin-bottom: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
